import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xs-6 col-xs-offset-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1)
const _hoisted_4 = { class: "form-horizontal tab-content infoBox" }
const _hoisted_5 = {
  key: 0,
  class: "text-center",
  role: "tabpanel"
}
const _hoisted_6 = {
  key: 0,
  class: "h4"
}
const _hoisted_7 = {
  key: 1,
  class: "h4"
}
const _hoisted_8 = { class: "col-sm-10 col-sm-offset-1 text-center" }
const _hoisted_9 = ["innerHTML"]

import { computed, onMounted, ref } from "vue";
import cms from "../../services/cms/cms";
import { CmsTeamEffectivenessReview } from "../../services/cms/cms-type-definitions";
import cmsContentMap from "../../services/cms/cms-content-map";
import HeadFromModel from "./head-from-model.vue";

const KIND = "TeamEffectivenessAggregateDiamond";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-effectiveness-head-with-info',
  props: {
    reviewId: { default: null }
  },
  setup(__props: any) {

const props = __props;

const doc = ref<CmsTeamEffectivenessReview | null>(null);

const selected = ref("");

function select(leaderType: string): void {
  selected.value = leaderType;
}

const tab = computed(() => {
  if (!doc.value) {
    return null;
  }

  const data = doc.value.data.body.find((s) => s.primary.question_id === selected.value)?.primary;

  if (!data) {
    return null;
  }

  return {
    title: cms.asText(data.question_title),
    content: cms.asHtml(data?.question_panel_text),
  };
});

onMounted(() => {
  cms
    .getByUid("cms-team-effectiveness-review", cmsContentMap.teamEffectiveness.questionnaireUid)
    .then((d) => {
      doc.value = d;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeadFromModel, {
          onLeaderTypeSelection: select,
          style: {"width":"80%","margin":"0 auto"},
          kind: KIND,
          headId: _ctx.reviewId
        }, null, 8, ["headId"])
      ])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (!tab.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (doc.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Click on a square to be reminded of the question."))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, "Loading..."))
          ]))
        : (_openBlock(), _createElementBlock("div", {
            class: "row",
            key: selected.value,
            role: "tabpanel"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", null, _toDisplayString(tab.value.title), 1),
              _createElementVNode("div", {
                innerHTML: tab.value.content
              }, null, 8, _hoisted_9)
            ])
          ]))
    ])
  ]))
}
}

})